import { useEffect, useState } from 'react';
import { apiRequest } from 'helpers/api';

type HourRange = {
  from: string;
  to: string;
};

type HourDay = {
  day_id?: number | null;
  dow: string;
  ranges: HourRange[];
};

export type ThirdPartyMenu = {
  x_menu_id: string;
  name: string;
  menu_type?: string;
  display_hours: HourDay[];
};

type ThirdPartyMenuResponse = {
  menus: ThirdPartyMenu[];
};

export const useGetMenuThirdParty = (restaurantId: string | undefined, source: string) => {
  const [isGetMenuThirdPartyRequestLoading, setIsGetMenuThirdPartyRequestLoading] = useState(true);
  const [hasGetMenuThirdPartyRequestError, setHasGetMenuThirdPartyRequestError] = useState(false);
  const [getMenuThirdPartyRequestResponse, setGetMenuThirdPartyRequestResponse] =
    useState<ThirdPartyMenuResponse | null>(null);

  useEffect(() => {
    if (!restaurantId) return;

    const getMenuThirdParty = async () => {
      setIsGetMenuThirdPartyRequestLoading(true);
      setHasGetMenuThirdPartyRequestError(false);

      const { data, error } = await apiRequest({
        path: `restaurant/${restaurantId}/menu-third-party?source=${source.toLowerCase()}`,
      });

      setIsGetMenuThirdPartyRequestLoading(false);

      if (error) {
        setHasGetMenuThirdPartyRequestError(true);
      } else {
        setGetMenuThirdPartyRequestResponse(data as ThirdPartyMenuResponse);
      }
    };

    void getMenuThirdParty();
  }, [restaurantId, source]);

  return {
    hasGetMenuThirdPartyRequestError,
    isGetMenuThirdPartyRequestLoading,
    getMenuThirdPartyRequestResponse,
  };
};
